import { createFileRoute } from "@tanstack/react-router";
import AdminClubPro from "@/pages/admin/AdminClubPro";

export const Route = createFileRoute("/admin/club-pro")({ component: AdminClubPro });
